import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, ArrowLeft } from 'lucide-react';
import Payment from './Payment';
import { CONTACT } from '../mock';
import logo from '../assets/collins_logo.png';

const PayPage = () => (
  <div className="bg-app min-h-screen flex flex-col">
    <header className="border-b border-white/10 bg-[#08090c]/90 backdrop-blur-md">
      <nav className="max-w-7xl mx-auto px-5 lg:px-8 h-[68px] flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <img src={logo} alt="Collins Technologiez" className="h-11 w-auto object-contain" />
          <span className="leading-tight">
            <span className="block font-cond font-700 text-white text-[15px] tracking-wide">
              COLLINS <span className="text-sky-400">TECHNOLOGIEZ</span>
            </span>
            <span className="block text-[10px] tracking-[0.25em] text-gray-500 uppercase">Repair Specialists</span>
          </span>
        </Link>

        <div className="flex items-center gap-4">
          <Link to="/" className="nav-link text-sm font-medium hidden sm:flex items-center gap-1.5">
            <ArrowLeft className="w-4 h-4" /> Back to site
          </Link>
          <a
            href={`tel:+1${CONTACT.phone}`}
            className="btn-blue px-4 py-2 rounded-md text-sm font-semibold flex items-center gap-2"
          >
            <Phone className="w-4 h-4" /> Call Now
          </a>
        </div>
      </nav>
    </header>

    <main className="flex-1">
      <Payment />
    </main>

    <footer className="bg-[#06070a] border-t border-white/10 py-8">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <img src={logo} alt="Collins Technologiez LLC" className="h-9 w-auto object-contain" />
          <span className="font-cond font-700 text-white text-sm tracking-wide">
            COLLINS <span className="text-sky-400">TECHNOLOGIEZ</span> LLC
          </span>
        </div>
        <p className="text-sm text-gray-500">
          {CONTACT.phoneDisplay} · <a href={`mailto:${CONTACT.email}`} className="text-sky-400 hover:underline">{CONTACT.email}</a>
        </p>
      </div>
    </footer>
  </div>
);

export default PayPage;
